module.exports = __webpack_public_path__ + "img/mind_skeleton_28.25abc380.png";